import axios from 'axios';
import API_BASE_URL from '../../../../config/apiConfig';

const API_URL = `${API_BASE_URL}/api/IACarePlan/generate`;

export const generateIACarePlan = async (patientData) => {
  // HIPAA: no loguear payload, respuesta, headers ni error.response.data
  // (contienen PHI y el token Bearer) — 45 CFR 164.530(c)
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(API_URL, patientData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    return response.data; // { resultado: "..." }
  } catch (error) {
    console.error(
      "[IA CarePlan] Error generating care plan:",
      error.response?.status,
      error.message
    );
    throw error;
  }
};